<template>
  <div class="full-content">
    <div class="setapp_time_limit">{{$t('Add Exception')}}</div>
    <div class="add_exce">
      <div class="add_exce_top">
        <p class="add_exce_top_p">{{$t('Enter URL')}}</p>
        <el-input style="font-size: 18px;" v-model="input" placeholder="Example : facebook.com"></el-input>
      </div>
      <div class="add_exce_botm">
        <p class="add_exce_botm_p">{{$t('Rule')}}</p>
        <div class="setapp-mian-div flex-row-center">
          <div class="app-main-note flex-row-center-start">
            <img :src="$Image('pre.png')" alt="">
            <span class="prevent_span">{{$t('Prevent')}}</span>
          </div>
          <div class="flex-row-end">
             <el-radio v-model="radio" :label="false" @change="agreeChange"><span></span></el-radio>
           </div>
        </div>
        <div class="setapp-mian-div flex-row-center">
          <div class="app-main-note flex-row-center-start">
            <img :src="$Image('alw.png')" alt="">
            <span class="allow_span">{{$t('Allow')}}</span>
          </div>
          <div class="flex-row-end">
             <el-radio v-model="radio" :label="true" @change="agreeChange"><span></span></el-radio>
           </div>
        </div>
      </div>
    </div>
    <div class="flex-row-center buy-footer">
      <el-button class="normalBtn buy-footer-btn" @click="OnAddException">{{$t('Add Exception')}}
      </el-button>
      <el-button class="otherBtn buy-footer-btn" @click="onCancel">{{$t('Cancel')}}
      </el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'add-exception',
  props: ['url'],
  data () {
    return {
      input: '',
      radio: false,
      optSelect: false
    }
  },
  methods: {
    agreeChange (e) {
      console.log(e)
      this.optSelect = e
    },
    OnAddException () {
      let value = this.input.trim()
      if (value !== '') {
        // this.input = this.url
        console.log(value)
        this.$emit('OnAddException', this.optSelect, value)
      } else {
        console.log('Website address required')
      }
    },
    // 关闭组件
    onCancel () {
      this.$emit('onCancel', true)
    }
  },
  mounted () {
    console.log(this.$route.query.url)
    this.input = this.$route.query.url
    console.log(this.optSelect)
  },
  watch: {
    '$route' (to, from) {
      console.log(to, from)
    }
  }
}
</script>
<style lang="scss" scoped>
.setapp_time_limit{
  border-bottom: 1px solid #e5e5e5;
  width: 100%;
  font-size: 24px;line-height: 54px;color: #333333;
  padding: 10px 0;
}
.add_exce{
  height: 77%;
  padding: 0 20%;
}
.add_exce_top_p{
  font-size: 20px;
  line-height: 54px;
  color: #333333;
  text-align: left;
  padding-top: 12%;
}
.add_exce_botm_p{
  font-size: 20px;
  line-height: 54px;
  color: #333333;
  text-align: left;
  padding-top: 8%;
}
.setapp-mian-div{
  border-bottom: 1px solid #e5e5e5;
  padding: 3% 0;
}
.prevent_span{
  font-size: 18px;color: #fd5955;margin-left: 17px;
}
.allow_span{
  font-size: 18px;color: #2bcf88;margin-left: 17px;
}
.buy-footer {
  height: 10%;
  border-top: 1px solid #e5e5e5;
  padding: 1%;
}
.buy-footer-btn{
  height: 50px;
  width: 191px;
  border-radius: 50px;
  font-size: 20px;
}
@media (max-width: 480px){
  .add_exce {
    padding: 0 10%;
  }
}
@media (max-width: 414px){
  .buy-footer-btn {
    height: 40px;
    width: 130px;
    font-size: 14px;
  }
}
@media (max-width: 375px){
  .add_exce{
    height: 73%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AddException.vue